import { Input, ColorPicker, Slider } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useRecoilValue, useRecoilState } from 'recoil'
import { selectedItemAtom, itemSelector } from 'atoms'
import { useTranslation } from 'react-i18next'

export const BorderDrawer = () => {
  const { t } = useTranslation()
  const selectedItem = useRecoilValue(selectedItemAtom)
  const [color, setColor] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.borderColor' }),
  )

  const [thickness, setThickness] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.borderThickness' }),
  )
  const [cornerRadius, setCornerRadiuses] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.borderRadius' }),
  )
  const circle = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'edits.circle' }),
  )
  const feather = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'edits.feather' }),
  )
  const width = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'width' }),
  )
  const height = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'height' }),
  )

  const largestDimension = width > height ? width : height

  return (
    <Flex column padding="0 12px">
      <Text>{t('editor.menus.properties.elements.radiusLabel')}</Text>
      <Slider
        sliderState={[cornerRadius, setCornerRadiuses]}
        min="0"
        max={largestDimension}
        margin="0 0 20px"
        initialValue={0}
        disabled={circle}
      />
      <Flex margin="0 0 16px">
        <Input
          label={t('editor.menus.properties.elements.thicknessLabel')}
          width="50%"
          margin="0 16px 0 0"
          value={[thickness, setThickness]}
          type="number"
          disabled={feather}
        />
      </Flex>
      <ColorPicker
        color={[color, setColor]}
        label={t('editor.menus.properties.elements.colorLabel')}
        margin="0 0 16px 0"
        disabled={feather}
      />
    </Flex>
  )
}

export default BorderDrawer
